import WModal from './modal';

WModal.install = (Vue) => {
  Vue.component(WModal.name, WModal);
};

export default WModal;
